import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { type ReactNode } from 'react'

export const DIALOG_ERROR = 'DialogError'

export interface DialogErrorProps {
  title: ReactNode
  description: ReactNode
  confirmText: ReactNode
  onConfirm: () => void
}

export const DialogError = () => {
  const { open, onConfirm, title, description, confirmText } = useDialog<DialogErrorProps>(DIALOG_ERROR)

  return (
    <Dialog open={open} fullWidth maxWidth={320}>
      <DialogHeader title={title} />
      <DialogContent justifyContent="center">
        <Text align="center">{description}</Text>
      </DialogContent>
      <DialogActions justifyContent="center">
        <Button fullWidth onClick={onConfirm}>{confirmText}</Button>
      </DialogActions>
    </Dialog>
  )
}
